import styled from 'styled-components';

export const FormSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10rem;
`;
